import SendMailPopup from "components/carModelPage/popups/showrooms/SendMailPopup"
import { useState } from "react"
import { useTypedSelector } from "store"
import styled from "styled-components"
import { TypographyCenter } from "theme/shared"
import { Font } from "../wizard/constants"

const StyledContainer = styled.div`
  display: flex;
  inset: auto 30px 30px 30px;
  width: auto;
  position: absolute;
`

const StyledFakeButton = styled.div<{ $dark?: boolean }>`
  background-color: ${(p) => p.theme.colors.black};
  border-radius: 3px;
  height: 45px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: ${(p) => p.theme.colors.white};
  :hover {
    background: #999;
    border: 0;
  }
  border: ${(p) =>
    p?.$dark ? "none" : `2px solid ${p?.theme?.colors?.black}`};
`

const StyledTypography = styled(TypographyCenter)`
  font-size: 16px;
  font-family: ${Font.OENaPro};
  font-weight: 400;
`

const SendToMailButton = () => {
  const { wizard } = useTypedSelector((state) => state)

  const [sendMailPopupOpen, setSendMailPopupOpen] = useState(false)

  if (!wizard?.model?.id) return

  return (
    <StyledContainer>
      <StyledFakeButton onClick={() => setSendMailPopupOpen(true)}>
        <StyledTypography variant="body2">
          שלחו לי את הסיכום למייל
        </StyledTypography>
      </StyledFakeButton>

      <SendMailPopup
        open={sendMailPopupOpen}
        onClose={() => {
          setSendMailPopupOpen(false)
        }}
      />
    </StyledContainer>
  )
}

export default SendToMailButton
